export default __webpack_public_path__ + "static/media/Arm Straps of the Warded Brute.77d4f3bd.jpg";